import { render } from "./NewXSLFileDIfference.vue?vue&type=template&id=0455f58a&scoped=true"
import script from "./NewXSLFileDIfference.vue?vue&type=script&lang=js"
export * from "./NewXSLFileDIfference.vue?vue&type=script&lang=js"

import "./NewXSLFileDIfference.vue?vue&type=style&index=0&id=0455f58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0455f58a"]])

export default __exports__